module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-04.dfbf707e.png";